<template>
  <v-container fluid>
    <v-flex>
      <v-row class="font-weight-bold pl-6 fontSize-24 mb-4" style="font-size: 24px;">사용자 관리</v-row>
    </v-flex>
    <v-card>
      <v-card-subtitle>
        <v-icon
          class="mr-2"
          style="background-color: #969696;border-radius: 20px;"
        >mdi-information-variant</v-icon>
        <span>사용자를 관리하는 화면</span>
      </v-card-subtitle>
    </v-card>
    <v-row>
      <v-col cols="12" class="pb-0">
        <v-layout justify-end>
          <v-btn class="primary" v-on:click="retrieveUser">
            <v-icon class="mr-1" style="font-size: 16px;">mdi-magnify</v-icon>조회
          </v-btn>
        </v-layout>
      </v-col>
      <v-col class="pr-3">
        <v-layout justify-end>
          <v-btn class="primary mr-3" @click="addRow" :disabled="!flags.inited">
            <v-icon class="mr-1" style="font-size: 16px;">mdi-plus</v-icon>추가
          </v-btn>
          <v-btn class="primary mr-3" @click="deleteRow" :disabled="!flags.inited">
            <v-icon class="mr-1" style="font-size: 16px;">mdi-minus</v-icon>삭제
          </v-btn>
          <v-btn class="primary" @click="save" :disabled="!flags.inited">
            <v-icon class="mr-1" style="font-size: 16px;">mdi-check</v-icon>저장
          </v-btn>
        </v-layout>
      </v-col>
    </v-row>
    <div class="flex flex-wrap">
      <!-- 그리드 영역 -->
      <realgrid
        ref="userGrid"
        class="mt-1 mb-5 w-full"
        :options="grid.gridOption"
        :fields="grid.gridFields"
        :columns="grid.gridColumns"
        :retrieveData="retrieveData"
        :retrieveApi="retreiveGrid"
        :saveApi="saveGrid"
        :height="grid.height"
      ></realgrid>
      <!-- 팝업영역: slot_content 팝업 -->
      <!-- <content-popup
      :visible="popup.slot_contents"
      :close="closePopup"
      kind="slot_contents"
      :title="popup.slotForm.popupTitle"
      yesBtn="추가"
      noBtn="취소"
      :widths="popup.contentPopupWidths"
      >-->
      <!-- slot 영역 : 사용자가 추가하여 사용, 슬롯으로 작업 시 title만 변경(kind, title, yesBtn, noBtn 필요) -->
      <!-- 아이디 -->
      <v-dialog max-width="600" v-model="showDialog">
        <v-card style="padding: 2rem;">
          <v-card-title class="w-full ma-0 pa-0 pl-3 pr-3">
            <v-flex class="flex-wrap">
              <v-row>
                <v-col cols="12" class="pa-0 pl-3 pr-3">
                  <v-text-field
                    label="ID"
                    v-model="popup.slotForm.inputData.user_id"
                    class="iotframe_txt w-full"
                    :class="{'border_red': !popup.slotValidation.isUserIdCheck && popup.slotPopupInited}"
                  />
                </v-col>
              </v-row>
            </v-flex>
          </v-card-title>
          <!-- 비밀번호 -->
          <v-card-title class="w-full ma-0 pa-0 pl-3 pr-3">
            <v-flex class="flex-wrap">
              <v-row>
                <v-col cols="12" class="pa-0 pl-3 pr-3">
                  <v-text-field
                    type="password"
                    label="비밀번호"
                    v-model="popup.slotForm.inputData.password"
                    class="iotframe_txt w-full"
                    :class="{'border_red': !popup.slotValidation.isPwCheck && popup.slotPopupInited}"
                  />
                </v-col>
              </v-row>
            </v-flex>
          </v-card-title>
          <!-- 비밀번호 확인 -->
          <v-card-title class="w-full ma-0 pa-0 pl-3 pr-3">
            <v-flex class="flex-wrap">
              <v-row>
                <v-col cols="12" class="pa-0 pl-3 pr-3">
                  <v-text-field
                    type="password"
                    label="비밀번호 확인"
                    v-model="popup.slotForm.inputData.passwordConfirm"
                    class="iotframe_txt w-full"
                    :class="{'border_red': !popup.slotValidation.isPwConfirmCheck && popup.slotPopupInited}"
                  />
                </v-col>
              </v-row>
            </v-flex>
          </v-card-title>
          <!-- 이름 -->
          <v-card-subtitle class="w-full ma-0 pa-0 pl-3 pr-3">
            <v-flex class="flex-wrap">
              <v-row>
                <v-col cols="12" class="pa-0 pl-3 pr-3">
                  <v-text-field
                    label="이름"
                    v-model="popup.slotForm.inputData.kor_nm"
                    class="iotframe_txt w-full"
                    :class="{'border_red': !popup.slotValidation.isKorNmCheck && popup.slotPopupInited}"
                  />
                </v-col>
              </v-row>
            </v-flex>
          </v-card-subtitle>
          <!-- 그룹 -->
          <v-card-subtitle class="w-full ma-0 pa-0 pl-3 pr-3">
            <v-flex class="flex-wrap">
              <v-row>
                <v-col cols="12" class="pa-0 pl-3 pr-3">
                  <v-select
                    label="그룹"
                    :items="groupItem"
                    item-text="txt"
                    item-value="val"
                    v-model="popup.slotForm.inputData.company"
                  ></v-select>
                </v-col>
              </v-row>
            </v-flex>
          </v-card-subtitle>
          <!-- 휴대폰번호 -->
          <v-card-subtitle class="w-full ma-0 pa-0 pl-3 pr-3">
            <v-flex class="flex-wrap">
              <v-row>
                <v-col cols="12" class="pa-0 pl-3 pr-3">
                  <v-text-field
                    label="휴대폰 번호"
                    v-model="popup.slotForm.inputData.phone"
                    class="iotframe_txt w-full"
                    :class="{'border_red': !popup.slotValidation.isPhoneCheck && popup.slotPopupInited}"
                    maxlength="11"
                  />
                </v-col>
              </v-row>
            </v-flex>
          </v-card-subtitle>
          <!-- 이메일 -->
          <v-card-subtitle class="w-full ma-0 pa-0 pl-3 pr-3">
            <v-flex class="flex-wrap">
              <v-row>
                <v-col cols="12" class="pa-0 pl-3 pr-3">
                  <v-text-field
                    label="이메일"
                    v-model="popup.slotForm.inputData.email"
                    class="iotframe_txt w-full"
                    :class="{'border_red': !popup.slotValidation.isEmailCheck && popup.slotPopupInited}"
                  />
                </v-col>
              </v-row>
            </v-flex>
          </v-card-subtitle>
          <v-card-subtitle>
            <v-row>
              <v-btn v-on:click="addUser">추가</v-btn>
            </v-row>
          </v-card-subtitle>
          <!-- </content-popup> -->
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>

<script>
// 스크립트를 정의하는 부분
// 개발자 작업 영역
import { getUsers, saveUsers } from '@/api/common/user'
import { isUserId, isEmail, isPhoneNumber } from '@/utils/check'
// import { ContentPopup } from '@/components/popupSet'
import Realgrid from '@/components/grid/UserManageGrid'
import { getCompanySample } from '@/api/common/sample'

export default {
  name: 'ManagerUser',
  // 팝업 컨포넌트 사용을 위한 설정
  components: {
    // ContentPopup,
    Realgrid
  },
  // .vue 내부에서 사용되는 model
  // model 기반으로 vue는 동작된다.
  data() {
    return {
      showDialog: false,
      // 사용자 조회시 넘어가는 파라미터 (조회조건)
      groupItem: [{ txt: '현대중공업', val: 'HHI' }],
      retrieveData: {
        user_id: '',
        kor_nm: '',
        phone: '',
        email: '',
        company: '',
        update_date: '',
        update_user_id: ''
      },
      grid: {
        gridOption: {
          gridView: {
            edit: {
              appendable: true,
              insertable: true,
              deletable: true
            },
            setGroupingOptions: {
              enabled: false // header 그룹핑 옵션을 사용하지 않는다.
            },
            checkBar: {
              visible: false
            },
            panel: {
              visible: false
            },
            display: {
              // 그리드 너비에 맞춰 컬럼 너비 자동 조정
              fitStyle: 'even'
            }
          },
          dataProvider: {
            softDeleting: true,
            // 해당 옵션이 false 이면 추가된 행을 삭제했을 경우 -+ 표시가 생긴다.
            // true 이면 추가된 행은 바로 삭제, 기존에 존재하던 행은 - 표시
            deleteCreated: true
          }
        },
        gridFields: [],
        gridColumns: [],
        height: 507,
        gridView: '', // 그리드의 그리드 뷰
        dataProvider: '' // 그리드의 dataProvider
      },
      flags: {
        inited: false // 한번이라도 조회하면 true로 변경된다. (버튼 컨트롤 위함)
      },
      // 팝업 관련 변수들
      popup: {
        slot_contents: false, // 이 값을 true로 주면 slot 팝업이 열린다.
        slotForm: {
          // slot 팝업 내부에서 사용할 form 변수들
          popupTitle: '사용자 추가',
          inputData: {
            // slot 팝업 내 입력 데이터 변수
            user_id: '',
            kor_nm: '',
            phone: '',
            password: '',
            passwordConfirm: '', // 비밀번호 확인
            company: '', // 선택 그룹값
            companys: [], // 회사 리스트
            email: ''
          }
        },
        slotPopupInited: false,
        slotValidation: {
          // slot 팝업 내부에서 사용할 validation 관련 변수들
          // slot 팝업 내부에서 '추가' 버튼을 한번이라도 클릭할시 true로 변경
          isUserIdCheck: false, // 아이디 데이터 체크 완료시 true
          isKorNmCheck: true, // 이름 데이터 체크 완료시 true
          isPhoneCheck: false, // 전화번호 데이터 체크 완료시 true
          isPwCheck: false, // 비밀번호 데이터 체크 완료시 true
          isPwConfirmCheck: false, // 비밀번호 확인 데이터 체크 완료시 true
          isCompanyCheck: true, // 그룹 데이터 체크 완료시 true
          isEmailCheck: true // 이메일 데이터 체크 완료시 true
        },
        contentPopupWidths: {
          widthM: 'w-full',
          widthLg: 'w-1/2',
          widthXl: 'w-2/5'
        }
      }
    }
  },
  created() {
    // DOM이 만들어 지기 전 실행 되는 곳
    // Data를 사전에 준비할 경우 사용된다.
    this.grid.gridFields = [
      { fieldName: 'user_id', dataType: 'string' },
      { fieldName: 'kor_nm', dataType: 'string' },
      { fieldName: 'phone', dataType: 'string' },
      { fieldName: 'email', dataType: 'string' },
      { fieldName: 'company', dataType: 'string' },
      { fieldName: 'update_user_id', dataType: 'string' },
      { fieldName: 'update_date', dataType: 'string' },
      { fieldName: 'recent_connection_date', dataType: 'string' },

      // 보여지지는 않지만 추가시 password 데이터 셋을 위해 필드를 만들어둠
      { fieldName: 'password', dataType: 'string' }
    ]

    this.grid.gridColumns = [
      {
        name: 'user_id',
        fieldName: 'user_id',
        header: {
          text: '사용자 아이디'
        },
        styles: {
          background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
        },
        width: 150,
        // editable 옵션이 false 일 경우, 수정할 수 없다.
        editable: false
      },
      {
        name: 'kor_nm',
        fieldName: 'kor_nm',
        header: {
          text: '사용자 이름'
        },
        width: 100,
        styles: {
          textAlignment: 'center'
        }
      },
      {
        name: 'phone',
        fieldName: 'phone',
        header: {
          text: '전화번호'
        },
        width: 150,
        styles: {
          textAlignment: 'center',
          background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
        },
        // editable 옵션이 false 일 경우, 수정할 수 없다.
        editable: false
      },
      {
        name: 'email',
        fieldName: 'email',
        header: {
          text: 'Email'
        },
        width: 200,
        styles: {
          background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
        },
        editable: false
      },
      {
        name: 'company',
        fieldName: 'company',
        header: {
          text: '회사'
        },
        styles: {
          textAlignment: 'center'
        },
        width: 100
      },
      {
        name: 'update_user_id',
        fieldName: 'update_user_id',
        header: {
          text: '수정자'
        },
        width: 100,
        styles: {
          textAlignment: 'center',
          background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
        },
        // editable 옵션이 false 일 경우, 수정할 수 없다.
        editable: false
      },
      {
        name: 'update_date',
        fieldName: 'update_date',
        header: {
          text: '수정일'
        },
        styles: {
          textAlignment: 'center',
          background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
        },
        width: 100,
        // editable 옵션이 false 일 경우, 수정할 수 없다.
        editable: false
      },
      {
        name: 'recent_connection_date',
        fieldName: 'recent_connection_date',
        header: {
          text: '최근접속일자'
        },
        styles: {
          textAlignment: 'center',
          background: '#e0e8eb' // 수정 불가능 컬럼 배경색 회색
        },
        width: 100,
        // editable 옵션이 false 일 경우, 수정할 수 없다.
        editable: false
      }
    ]
  },
  mounted() {
    // 그리드에 직접 수정할 경우 필요한 validation 항목들
    var validations = [
      {
        criteria: "value['user_id'] is not empty",
        message: '사용자아이디는 필수값입니다.',
        mode: 'always',
        level: 'error'
      },
      {
        criteria: "value['kor_nm'] is not empty",
        message: '사용자이름은 필수값입니다.',
        mode: 'always',
        level: 'error'
      },
      {
        criteria: "value['company'] is not empty",
        message: '회사는 필수값입니다.',
        mode: 'always',
        level: 'error'
      }
    ]

    this.$refs.userGrid.getGridView().setValidations(validations)

    // DOM에 해당 .vue가 들어가게 되면 실행 되는 곳
    // onload 상태와 동일하다. DOM 이후에 조작할 경우 이곳에서 수행
    // 그리드 그려줌
    this.retrieveUser()

    // 그룹 셀렉트박스 샘플 데이터 셋팅
    // code는 실제 value 값, name 은 사용자에 보여지는 값
    getCompanySample().then(res => {
      if (res) {
        this.popup.slotForm.inputData.companys = res
        this.popup.slotForm.inputData.company = res[0].code
      } else {
        this.popup.slotForm.inputData.companys = []
        this.popup.slotForm.inputData.company = ''
      }
    })

    this.grid.gridView = this.$refs.userGrid.getGridView()
    this.grid.dataProvider = this.$refs.userGrid.getDataProvider()
  },
  computed: {
    retreiveGrid() {
      return getUsers
    },
    saveGrid() {
      return saveUsers
    }
  },
  methods: {
    // .vue 내부에서 사용되는 함수를 정의한다.
    // 이벤트에 따라 실행하거나, 내부적으로 사용되는 함수들을 정의한다.
    retrieveUser() {
      this.$refs.userGrid.retrieve()
      this.flags.inited = true
    },
    addRow() {
      this.showDialog = true
      // 수정 도중이면 현재 상황을 정리한다.
      // commit은 수정 줄이 수정 상태 그대로, cancel은 수정 이전 상태로 변경
      this.grid.gridView.commit()

      // 추가 버튼을 누르면 slot 팝업을 연다.
      this.popup.slot_contents = true
    },
    deleteRow() {
      this.$refs.userGrid.deleteRow()
    },
    save() {
      this.$refs.userGrid.save()
    },
    // 팝업을 닫을때 호출되는 함수
    closePopup(result) {
      if (result.ok) {
        this.addUser()
      } else {
        _.forEach(
          this.popup.slotForm.inputData,
          function(val, key) {
            // 회사리스트, 회사를 제외한 모든 값들 초기화
            if (key !== 'companys' && key !== 'company') {
              this.popup.slotForm.inputData[key] = ''
            } else if (key === 'company') {
              // 회사 초기값 샘플 초기값 셋팅
              this.popup.slotForm.inputData[key] = 'HHI'
            }
          }.bind(this)
        )
        this.popup[result.id] = false
        this.popup.slotPopupInited = false
      }
    },
    addUser() {
      // 추가 버튼 한번이라도 클릭하면 true로 바꿔줌
      // this.popup.slotPopupInited = true
      // validation 함수의 return 값이 true 일때만 다음 작업을 진행한다.
      if (this.popupValidation(this.popup.slotForm.inputData)) {
        // row가 추가되기 전 current
        console.log('test#####################1')
        var currentCellIndex = this.grid.gridView.getCurrent()
        console.log('test#####################2')
        // currentCell 의 위치에 따라 row 삽입 위치를 정한다.
        if (currentCellIndex.itemIndex < 0) {
          console.log('test#####################3')
          // 그리드 마지막 행 이후에 삽입
          this.grid.gridView.beginAppendRow()
        } else {
          console.log('test#####################4')
          // 현재 currentCell의 다음으로 삽입
          this.grid.gridView.beginInsertRow(currentCellIndex.itemIndex, true)
        }
        console.log('test#####################5')
        // 그리드에 입력될 데이터들 = slot 팝업에서 입력한 데이터들
        var values = {
          user_id: this.popup.slotForm.inputData.user_id,
          password: this.popup.slotForm.inputData.password,
          kor_nm: this.popup.slotForm.inputData.kor_nm,
          company: this.popup.slotForm.inputData.company,
          phone: this.popup.slotForm.inputData.phone,
          email: this.popup.slotForm.inputData.email
        }
        console.log('test#####################6')
        // 그리드에 값을 넣어준다
        this.grid.gridView.setValues(
          this.grid.gridView.getCurrent().itemIndex,
          values,
          false
        )
        console.log('test#####################7')

        // slot 팝업 닫음
        // this.popup.slot_contents = false

        // slot 팝업 내 input 영역 초기화
        _.forEach(
          this.popup.slotForm.inputData,
          function(val, key) {
            // 회사리스트, 회사를 제외한 모든 값들 초기화
            if (key !== 'companys' && key !== 'company') {
              this.popup.slotForm.inputData[key] = ''
            } else if (key === 'company') {
              // 그룹은 초기값 샘플 초기값 셋팅
              this.popup.slotForm.inputData[key] = 'HHI'
            }
          }.bind(this)
        )
        // this.popup.slotPopupInited = false
      }
      this.showDialog = false
    },
    // slot 팝업 내 입력부분 유효성 체크
    popupValidation(inputData) {
      var returnFlag = true // returnFlag 의 초기값은 true
      var gridAllData = this.grid.dataProvider.getJsonRows(-1) // 그리드의 전체 데이터 가져옴

      // 아이디 유효성 검사
      if (!inputData.user_id) {
        this.popup.slotValidation.isUserIdCheck = false
      } else if (!isUserId(inputData.user_id)) {
        // 아이디 정규식으로 체크 (check.js 의 함수 호출)
        this.popup.slotValidation.isUserIdCheck = false
      } else {
        this.popup.slotValidation.isUserIdCheck = true
      }
      // 비밀번호 유효성 검사
      if (!inputData.password) {
        this.popup.slotValidation.isPwCheck = false
      } else {
        this.popup.slotValidation.isPwCheck = true
      }
      // else if (inputData.password === inputData.user_id) {
      //   // 아이디와 비밀번호는 같을 수 없다
      //   this.popup.slotValidation.isPwCheck = false
      // } else if (!isPw(inputData.password)) {
      //   // 비밀번호 정규식으로 체크 (check.js 의 함수 호출)
      //   this.popup.slotValidation.isPwCheck = false
      // } else {
      //   this.popup.slotValidation.isPwCheck = true
      // }

      // 비밀번호 확인 유효성 검사
      if (!inputData.passwordConfirm) {
        this.popup.slotValidation.isPwCheck = false
        this.popup.slotValidation.isPwConfirmCheck = false
      } else if (inputData.passwordConfirm === inputData.user_id) {
        // 아이디와 비밀번호는 같을 수 없다
        this.popup.slotValidation.isPwCheck = false
        this.popup.slotValidation.isPwConfirmCheck = false
      } else if (inputData.password !== inputData.passwordConfirm) {
        // 비밀번호와 비밀번호 확인은 같아야한다
        this.popup.slotValidation.isPwCheck = false
        this.popup.slotValidation.isPwConfirmCheck = false
      } else {
        this.popup.slotValidation.isPwCheck = true
        this.popup.slotValidation.isPwConfirmCheck = true
      }
      // 이름 필수값 체크
      if (!inputData.kor_nm) {
        this.popup.slotValidation.isKorNmCheck = false
      } else {
        this.popup.slotValidation.isKorNmCheck = true
      }
      // 그룹 필수값 체크
      if (!inputData.company) {
        this.popup.slotValidation.isCompanyCheck = false
      } else {
        this.popup.slotValidation.isCompanyCheck = true
      }
      // 전화번호 유효성 체크
      if (!inputData.phone) {
        this.popup.slotValidation.isPhoneCheck = false
      } else if (!isPhoneNumber(inputData.phone)) {
        // 전화번호 정규식으로 체크 (check.js 의 함수 호출)
        this.popup.slotValidation.isPhoneCheck = false
      } else {
        this.popup.slotValidation.isPhoneCheck = true
      }
      // 이메일 유효성 체크
      if (!inputData.email) {
        this.popup.slotValidation.isEmailCheck = false
      } else if (!isEmail(inputData.email)) {
        // 이메일 정규식으로 체크 (check.js 의 함수 호출)
        this.popup.slotValidation.isEmailCheck = false
      } else {
        this.popup.slotValidation.isEmailCheck = true
      }
      // 그리드 전체 데이터와 중복된 값이 있는지 검사 (아이디, 전화번호, 이메일)
      // API 통신이 아닌 그리드 데이터를 가지고 검사하는 이유는
      // 그리드에는 추가 되었지만 저장을 누르지 않은 상태의 데이터들과도 중복체크를 하기 위함
      gridAllData.forEach(
        function(rowData) {
          if (rowData.user_id === inputData.user_id) {
            this.popup.slotValidation.isUserIdCheck = false
          }
          if (rowData.phone === inputData.phone) {
            this.popup.slotValidation.isPhoneCheck = false
          }
          if (rowData.email === inputData.email) {
            this.popup.slotValidation.isEmailCheck = false
          }
        }.bind(this)
      )

      // slot 팝업 validation Flag 들중 하나라도 false 이면 false를 리턴한다.
      _.forEach(this.popup.slotValidation, function(val, key) {
        if (!val) {
          returnFlag = false
        }
      })

      return returnFlag
    }
  }
}
</script>

<style lang="less" scoped>
/* css 혹은 less로 스타일 정의하는 부분 */
.border_red {
  border-color: #f63440;
}
</style>
